/**
 * br-reforma-scroll-statement — character-by-character scroll scrub.
 *
 * The donor starts every character at 32% opacity and reveals the run
 * sequentially. Browser measurements at 390x844 showed the reveal
 * starting when the text top reaches ~95% of the viewport and ending
 * when it reaches ~28% of its own height above the viewport.
 */
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const sections = new Set();
  let frame = 0;

  const splitText = (element) => {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const textNodes = [];

    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.trim()) textNodes.push(walker.currentNode);
    }

    const characters = [];

    textNodes.forEach((textNode) => {
      const fragment = document.createDocumentFragment();
      const parts = textNode.nodeValue.split(/(\s+)/);

      parts.forEach((part) => {
        if (!part) return;

        if (/^\s+$/.test(part)) {
          fragment.appendChild(document.createTextNode(part));
          return;
        }

        const word = document.createElement('span');
        word.className = 'br-reforma-scroll-statement__word';

        Array.from(part).forEach((letter) => {
          const character = document.createElement('span');
          character.className = 'br-reforma-scroll-statement__character';
          character.textContent = letter;
          character.style.opacity = '0.32';
          word.appendChild(character);
          characters.push(character);
        });

        fragment.appendChild(word);
      });

      textNode.replaceWith(fragment);
    });

    return characters;
  };

  const update = () => {
    frame = 0;

    sections.forEach((section) => {
      const text = section.querySelector('[data-br-reforma-scroll-statement-text]');
      const characters = section.brReformaScrollCharacters;
      if (!text || !characters || !characters.length) return;

      if (reducedMotion.matches) {
        characters.forEach((character) => {
          character.style.opacity = '1';
        });
        return;
      }

      const rect = text.getBoundingClientRect();
      const start = window.innerHeight * 0.955;
      const end = rect.height * -0.28;
      const progress = Math.min(1, Math.max(0, (start - rect.top) / (start - end)));
      const boundary = progress * characters.length;

      characters.forEach((character, index) => {
        const localProgress = Math.min(1, Math.max(0, boundary - index));
        character.style.opacity = String(0.32 + 0.68 * localProgress);
      });
    });
  };

  const requestUpdate = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };

  const setup = (section) => {
    if (section.dataset.brReformaScrollStatementReady === 'true') return;
    section.dataset.brReformaScrollStatementReady = 'true';

    const text = section.querySelector('[data-br-reforma-scroll-statement-text]');
    if (!text) return;

    section.brReformaScrollCharacters = splitText(text);
    sections.add(section);
    requestUpdate();
  };

  document.querySelectorAll('[data-br-reforma-scroll-statement]').forEach(setup);
  /*
   * Horizon scrolls inside `.page-wrapper` at desktop widths. Scroll
   * events do not bubble, so listen in the capture phase at `document`
   * to cover both that nested root and native document scrolling.
   */
  document.addEventListener('scroll', requestUpdate, { capture: true, passive: true });
  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  reducedMotion.addEventListener('change', requestUpdate);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-br-reforma-scroll-statement]').forEach(setup);
  });
})();
